import { useSelector } from "react-redux";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getAdminSelectedCompanyId } from "../../../../helpers/adminSelectors";
import CompanyVisibility from "./CompanyVisibility";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    border: "1px solid #EEE",
    boxShadow: "0 2px 0 0 rgba(129,129,129,0.10)",
    borderRadius: 10,
  },
  actionButtons: {
    justifyContent: "space-between",
    "& > div": {
      border: "none",
      width: "unset",
      marginTop: "-2px",
      padding: "0px",
      "& button": {
        height: "26px",
      },
    },
    "& :only-child": {
      marginLeft: "auto",
    },
  },
  btnDesign: {
    fontSize: "12px",
    lineHeight: "14px",
  },
  head: {
    padding: "15px 20px",
    borderBottom: "2px solid #F5F5F5",
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
  },
  headTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: "0px",
  },
  headSubTitle: {
    marginTop: "-2px",
    fontSize: 14,
    fontWeight: 400,
  },
  headMarginBottom: {
    marginBottom: "10px",
  },
  body: {
    padding: 20,
  },
  card: {
    padding: 15,
    borderRadius: 4,
    border: "1px solid #F2F2F2",
    marginBottom: 15,
  },
  heading: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 10,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    marginRight: 10,
  },
  text: {
    fontSize: 12,
    marginBottom: 10,
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  textItalic: {
    fontSize: 12,
    fontStyle: "italic",
    marginBottom: 10,
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  greenLink: {
    fontSize: 12,
    color: theme.palette.primary.main,
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  greenIcon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 12,
    marginRight: 8,
    marginTop: 3,
  },
  selectBox: {
    display: "flex",
    alignItems: "center",
    marginTop: 15,
    "& .MuiFormControl-root": {
      width: "60%",
    },
  },
  logo: {
    background: theme.palette.common.white,
    borderColor: theme.palette.common.lightGrey,
    borderRadius: 0,
    borderStyle: "solid",
    borderWidth: 1,
    marginBottom: 10,
    maxWidth: 160,
    padding: 3,
    "&:hover": {
      animation: `$bgColorChange 1s linear`,
      backgroundColor: theme.palette.common.black,
    },
  },
  logoCard: {
    background: theme.palette.secondary.main,
    height: 140,
    padding: "10px",
    "&:hover": {
      animation: `$bgColorChange 1.2s linear`,
      backgroundColor: theme.palette.common.black,
    },
  },
  logoMail: {
    background: theme.palette.common.white,
    height: 140,
    padding: "10px",
    "&:hover": {
      animation: `$bgColorChangeMail 1.2s linear`,
      backgroundColor: theme.palette.common.black,
    },
  },
  selectCard: {
    height: 100,
    padding: "10px",
  },
  "@keyframes bgColorChange": {
    "0%": {
      backgroundColor: theme.palette.secondary.main,
    },
    "50%": {
      backgroundColor: theme.palette.common.black,
    },
    "100%": {
      backgroundColor: theme.palette.common.black,
    },
  },
  "@keyframes bgColorChangeMail": {
    "0%": {
      backgroundColor: theme.palette.common.white,
    },
    "50%": {
      backgroundColor: theme.palette.common.black,
    },
    "100%": {
      backgroundColor: theme.palette.common.black,
    },
  },
}));

const BasicSettings = () => {
  const classes = useStyles();

  const targetCompanyId = useSelector(getAdminSelectedCompanyId);

  return (
    <Grid container spacing={4}>
      <Grid item md={5} xs={12}>
        <CompanyVisibility
          classes={classes}
          targetCompanyId={targetCompanyId}
        />
      </Grid>
      <Box width="100%" />
    </Grid>
  );
};

export default BasicSettings;
